'use client';

import { PropsWithChildren, useContext, useEffect } from 'react';
import { pageByIdQuery } from './pageByIdQuery';
import { PagePatternContext } from '@/components/layout/PagePattern';

type Props = PropsWithChildren<{
  page: (typeof pageByIdQuery)[1];
}>;

export default function GenericPage({ page, children }: Props) {
  const { set: setPattern } = useContext(PagePatternContext);

  useEffect(() => {
    setPattern(page?.pattern ?? null);
  }, [page?.pattern]);


  return children;
}
